(function () {
  var stage = document.getElementById('tarot-stage');
  var data = document.getElementById('tarot-deck-data');
  if (!stage || !data) return;

  var deck = JSON.parse(data.textContent);
  if (stage.dataset.deck === 'major') {
    deck = deck.filter(function (c) {
      return c.slug.charAt(0) === 'm';
    });
  }

  var card = document.getElementById('tarot-card');
  var img = document.getElementById('tarot-card-img');
  var nameText = document.getElementById('tarot-card-name-text');
  var orientEl = document.getElementById('tarot-card-orientation');
  var meaning = document.getElementById('tarot-meaning');
  var p1 = document.getElementById('tarot-meaning-p1');
  var p2 = document.getElementById('tarot-meaning-p2');

  // Local date, so the card turns over at the visitor's midnight.
  // ?date=YYYY-MM-DD overrides it for testing. The format is checked so a
  // typo like ?date=2026-8-1 is ignored rather than silently drawing a
  // different card than the padded form would.
  function today() {
    var q = new URLSearchParams(location.search);
    var override = q.get('date') || q.get('tarot-date');
    if (override && /^\d{4}-\d{2}-\d{2}$/.test(override)) return override;
    var d = new Date();
    return (
      d.getFullYear() +
      '-' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getDate()).padStart(2, '0')
    );
  }

  // FNV-1a, then an avalanche finalizer. The finalizer matters: raw FNV
  // multiplies by an odd prime, so its lowest bit depends only on the
  // input's lowest bit. Without mixing, `% 2` and `% 78` stay correlated
  // and every card would be locked to one orientation forever.
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    h ^= h >>> 16;
    h = Math.imul(h, 2246822507);
    h ^= h >>> 13;
    h = Math.imul(h, 3266489909);
    h ^= h >>> 16;
    return h >>> 0;
  }

  // Same card and orientation for everyone, all day. Orientation uses a
  // salted second hash so it is independent of which card came up.
  var date = today();
  var chosen = deck[hash(date) % deck.length];
  var reversed = hash(date + '|orientation') % 2 === 1;

  img.src = chosen.url;
  img.alt = chosen.name;
  nameText.textContent = chosen.name;
  if (reversed) {
    card.classList.add('is-reversed');
    orientEl.textContent = 'odwrócona';
  }

  fetch(stage.dataset.meanings)
    .then(function (r) {
      return r.json();
    })
    .then(function (all) {
      var entry = all[chosen.slug];
      if (!entry) return;
      var text = reversed ? entry.rev : entry.up;
      if (!text) return;
      p1.textContent = text.p1;
      p2.textContent = text.p2;
      meaning.classList.add('has-text');
    })
    .catch(function () {});

  function reveal() {
    stage.classList.add('is-done');
  }

  // Run fn when el's transition ends, with a timer as a safety net in case
  // the transition never fires (reduced motion, interrupted animation).
  function afterTransition(el, fn) {
    var ran = false;
    function go() {
      if (ran) return;
      ran = true;
      fn();
    }
    el.addEventListener('transitionend', go, { once: true });
    setTimeout(go, 1200);
  }

  var inner = card.querySelector('.tarot-card__inner');
  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  card.addEventListener('click', function () {
    if (card.classList.contains('is-revealed')) return;
    card.setAttribute('aria-label', chosen.name);
    card.classList.add('is-revealed');

    if (noMotion) {
      if (reversed) card.classList.add('is-turned');
      reveal();
      return;
    }

    // Text appears once the card has finished moving, so nothing expands
    // into the layout mid-flip. Reversed cards turn over first, making the
    // reversal something you watch happen.
    afterTransition(inner, function () {
      if (!reversed) {
        reveal();
        return;
      }
      card.classList.add('is-turned');
      afterTransition(img, reveal);
    });
  });
})();
